import { CommonModule } from '@angular/common';
import { AfterContentInit, ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ElioSvgIconsModule } from '@elio/shared/icon-utils';
import { TranslocoModule } from '@ngneat/transloco';

@Component({
  selector: 'elio-toast-message',
  template: `<ng-content></ng-content>`,
  standalone: true,
  imports: [CommonModule, TranslocoModule, ElioSvgIconsModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastMessageComponent implements AfterContentInit {
  @Input() delay!: number | boolean;

  @Output() readonly hide = new EventEmitter<void>();

  ngAfterContentInit() {
    if (typeof this.delay === 'number') {
      setTimeout(() => this.hide.emit(), this.delay);
    }
  }
}
